export default { sha: '2387c8f8d1d44e04549198f1e834589686cf7e22', buildNumber: 'undefined' }
